//Default Buttons
export const FLAT_DEFAULT_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " class for flat button",
  },
];

export const FLAT_DEFAULT_BUTTONS_LIST = [
  {
    id: 2,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary",
  },
  {
    id: 3,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-success",
  },
  {
    id: 4,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-info",
  },
  {
    id: 5,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-warning",
  },
  {
    id: 6,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-danger",
  },
  {
    id: 7,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-light",
  },
];

//LargeButtons
export const FLAT_LARGE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-lg",
  },
  {
    text: " class for large size buttons",
  },
];

export const FLAT_LARGE_BUTTONS_LIST = [
  {
    id: 9,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary btn-lg",
  },
  {
    id: 10,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-success btn-lg",
  },
  {
    id: 11,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-info btn-lg",
  },
  {
    id: 12,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-warning btn-lg",
  },
  {
    id: 13,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-danger btn-lg",
  },
  {
    id: 14,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-light btn-lg",
  },
];

//SmallButton
export const FLAT_SMALL_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-sm",
  },
  {
    text: " class for small size buttons",
  },
];

export const FLAT_SMALL_BUTTONS_LIST = [
  {
    id: 16,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary btn-sm",
  },
  {
    id: 17,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-success btn-sm",
  },
  {
    id: 18,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-info btn-sm",
  },
  {
    id: 19,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-warning btn-sm",
  },
  {
    id: 20,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-danger btn-sm",
  },
  {
    id: 21,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-light btn-sm",
  },
];

//Extra Small Button
export const FLAT_EXTRA_SMALL_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-xs",
  },
  {
    text: " class for extra small size buttons",
  },
];

export const FLAT_EXTRA_SMALL_BUTTONS_LIST = [
  {
    id: 23,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary btn-xs",
  },
  {
    id: 24,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-success btn-xs",
  },
  {
    id: 25,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-info btn-xs",
  },
  {
    id: 26,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-warning btn-xs",
  },
  {
    id: 27,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-danger btn-xs",
  },
  {
    id: 28,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-light btn-xs",
  },
];

//Active Button
export const FLAT_ACTIVE_BUTTONS_LIST = [
  {
    id: 30,
    color: "secondary",
    btnText: "Active",
    tooltipText: "btn btn-square btn-secondary active",
  },
  {
    id: 31,
    color: "success",
    btnText: "Active",
    tooltipText: "btn btn-square btn-success active",
  },
  {
    id: 32,
    color: "info",
    btnText: "Active",
    tooltipText: "btn btn-square btn-info active",
  },
  {
    id: 33,
    color: "warning",
    btnText: "Active",
    tooltipText: "btn btn-square btn-warning active",
  },
  {
    id: 34,
    color: "danger",
    btnText: "Active",
    tooltipText: "btn btn-square btn-danger active",
  },
  {
    id: 35,
    color: "light",
    btnText: "Active",
    tooltipText: "btn btn-square btn-light active",
  },
];

//Outline Buttons
export const FLAT_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-outline-*",
  },
  {
    text: " class for button with outline",
  },
];

export const FLAT_OUTLINE_BUTTONS_LIST = [
  {
    id: 41,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-outline-secondary",
  },
  {
    id: 42,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-outline-success",
  },
  {
    id: 43,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-outline-info",
  },
  {
    id: 44,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-outline-warning",
  },
  {
    id: 45,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-outline-danger",
  },
  {
    id: 46,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-outline-light",
    className: "text-dark",
  },
];

//Bold Outline Buttons
export const FLAT_BOLD_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-outline-*-2x",
  },
  {
    text: " class for button with bold outline",
  },
];

export const FLAT_BOLD_OUTLINE_BUTTONS_LIST = [
  {
    id: 48,
    color: "secondary-2x",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-outline-secondary-2x",
  },
  {
    id: 49,
    color: "success-2x",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-outline-success-2x",
  },
  {
    id: 50,
    color: "info-2x",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-outline-info-2x",
  },
  {
    id: 51,
    color: "warning-2x",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-outline-warning-2x",
  },
  {
    id: 52,
    color: "danger-2x",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-outline-danger-2x",
  },
  {
    id: 53,
    color: "light-2x",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-outline-light-2x",
    className: "text-dark",
  },
];

//large Outline Buttons
export const FLAT_LARGE_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-lg",
  },
  {
    text: " class for large button",
  },
];

export const FLAT_LARGE_OUTLINE_BUTTONS_LIST = [
  {
    id: 55,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-outline-secondary btn-lg",
  },
  {
    id: 56,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-outline-success btn-lg",
  },
  {
    id: 57,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-outline-info btn-lg",
  },
  {
    id: 58,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-outline-warning btn-lg",
  },
  {
    id: 59,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-outline-danger btn-lg",
  },
  {
    id: 60,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-outline-light btn-lg",
    className: "text-dark",
  },
];

//Small Outline Buttons
export const FLAT_SMALL_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-sm",
  },
  {
    text: " class for small button",
  },
];

export const FLAT_SMALL_OUTLINE_BUTTONS_LIST = [
  {
    id: 62,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-outline-secondary btn-sm",
  },
  {
    id: 63,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-outline-success btn-sm",
  },
  {
    id: 64,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-outline-info btn-sm",
  },
  {
    id: 65,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-outline-warning btn-sm",
  },
  {
    id: 66,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-outline-danger btn-sm",
  },
  {
    id: 67,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-outline-light btn-sm",
    className: "text-dark",
  },
];

//Extra Small Outline Buttons
export const FLAT_EXTRA_SMALL_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-xs",
  },
  {
    text: " class for extra small button",
  },
];

export const FLAT_EXTRA_SMALL_OUTLINE_BUTTONS_LIST = [
  {
    id: 69,
    color: "secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-outline-secondary btn-xs",
  },
  {
    id: 70,
    color: "success",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-outline-success btn-xs",
  },
  {
    id: 71,
    color: "info",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-outline-info btn-xs",
  },
  {
    id: 72,
    color: "warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-outline-warning btn-xs",
  },
  {
    id: 73,
    color: "danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-outline-danger btn-xs",
  },
  {
    id: 74,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-outline-light btn-xs",
    className: "text-dark",
  },
];

//Gradien Button
export const FLAT_GRADIEN_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-square",
  },
  {
    text: " and ",
    code: ".btn-*-gradien",
  },
  {
    text: " class for gradien button",
  },
];

export const FLAT_GRADIEN_BUTTONS_LIST = [
  {
    id: 76,
    color: "secondary-gradien",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary-gradien",
  },
  {
    id: 77,
    color: "success-gradien",
    btnText: "Success Button",
    tooltipText: "btn btn-square btn-success-gradien",
  },
  {
    id: 78,
    color: "info-gradien",
    btnText: "Info Button",
    tooltipText: "btn btn-square btn-info-gradien",
  },
  {
    id: 79,
    color: "warning-gradien",
    btnText: "Warning Button",
    tooltipText: "btn btn-square btn-warning-gradien",
  },
  {
    id: 80,
    color: "danger-gradien",
    btnText: "Danger Button",
    tooltipText: "btn btn-square btn-danger-gradien",
  },
  {
    id: 81,
    color: "light-gradien",
    btnText: "Light Button",
    tooltipText: "btn btn-square btn-light-gradien",
    className: "text-dark",
  },
];
